export default "__VITE_ASSET__CXm5tSp0__"